import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderHierarchy extends Layout {
	sourceHierarchy: DataSource;
	tableOrderHierarchy: Table;
}
